import _ from 'lodash';
import { DateTime } from "luxon";

export class MockDataStore {
    constructor() {

        this.#addParent(MockDataStore.russetProperties, MockDataStore.hRCustomer);
        this.#addParent(MockDataStore.shaun, MockDataStore.hRCustomer);
        this.#addParent(MockDataStore.grahamFromLuton, MockDataStore.hRCompetitorCustomer);

    }

    #addParent = (landlord, company) => {
        landlord.parent = _.pick(company, ['id', 'name', 'createdBy', 'created', 'modifiedBy', 'modified']);
        return company;
    };

    // CreatedBy / Modified By
    static developer = {
        id: "6bebd073-a47f-4dba-a6c4-b3178add1b77",
        userName: "ian.danger.robertson@gmail.com",
        displayName: "Ian Robertson"
    }

    // Landlord
    static grahamFromLuton = {
        id: "659d19ce142315b705fda721",
        name: "graham_luton",
        displayName: "Graham From Luton",
        email: "graham@luton.com",
        phoneNumber: "07777 100 100",
        coordinates: { latitude: 54, longitude: - 0.53 }
    };

    // Landlord
    static shaun = {
        id: "659d19ce142315b705fda755",
        name: "irish_shaun",
        displayName: "Shaun From Ireland",
        email: "shaun@watford.com",
        phoneNumber: "07777 500 500",
        coordinates: { latitude: 54, longitude: - 0.53 }
    };

    // Landlord
    static russetProperties = {
        id: "659d19ce142315b705fda720",
        name: "russetproperties",
        displayName: "Russet Properties Ltd",
        email: "liz@harveyroe.com",
        phoneNumber: "07581 122 021",
        coordinates: { latitude: 54, longitude: - 0.53 },
        createdBy: MockDataStore.developer,
        modifiedBy: MockDataStore.developer,
        created: DateTime.utc().toISO(), modified: DateTime.utc().toISO(),
        contacts: [
            {
                name: "Ian Robertson Contact",
                email: "ian.danger.robertson+russet@gmail.com",
                phoneNumber: "07530 086434",
                role: "Co-Owner"
            }
        ],
        documents: []
    };

    // Customer
    static hRCustomer = {
        id: "659d3b56b5cf709deb2e3b2e",
        createdBy: MockDataStore.developer,
        modifiedBy: MockDataStore.developer,
        created: DateTime.utc().toISO(), modified: DateTime.utc().toISO(), name: "Harvey Roe",
        landlordsOrOwners: [MockDataStore.russetProperties]
    };

    // Customer
    static hRCompetitorCustomer = {
        id: "659d3c3eb5cf709deb2e3b31",
        createdBy: MockDataStore.developer,
        modifiedBy: MockDataStore.developer,
        created: DateTime.utc().toISO(), modified: DateTime.utc().toISO(), name: "Sheridan Blue",
        landlordsOrOwners: [MockDataStore.grahamFromLuton]
    };

    static companies = [MockDataStore.hRCustomer, MockDataStore.hRCompetitorCustomer]; // The real API would only return what you should see...
}